import { React, Icon, Container, Component, _ } from 'utils';
import './credits.less';
import { CreditStore } from 'model';
import moment from 'moment/src/moment';

class CreditsContainer extends Component {

	static getStores() {
		return [CreditStore];
	}

	static calculateState() {
		var state = Object.assign({}, CreditStore.getState());
		state.open = false;
		return state;
	}

	toggle = () => {
		var current = this.state.open;
		this.setState({open: !current });
	}

	render() {
		var { total, open, credits, limit } = this.state;
		var endOfService = moment(limit).format('DD.MM.YYYY');
		let IconPanelContent = null;
		let noCredits = <div className="buy-credits"><a href={this.props.buyUrl} className="btn btn-primary">{_('Kupi kredite')}</a></div>;

		var vCredits = credits.map(function(item, index) {
			return <div key={index} className="credit-status">
				<div className="period">
					<span>{ moment(item.startTime).format('DD.MM.YYYY') }</span> -
					<span>{ moment(item.endTime).format('DD.MM.YYYY') }</span>
				</div>
				<div className="usage">
					<div>
						<span className="name">{_('Kupljeno')}</span>
						<span className="value">{ item.credit }</span>
					</div>
					<div>
						<span className="name">{_('Raspoloživo')}</span>
						<span className="value"><strong>{ item.total }</strong></span>
					</div>
				</div>
			</div>
		});

		var css = ['credits'];
        var zeroCredits = ['fa fa-info-circle'];
		if(open) {
			css.push('open');
		}

		if (total > 0) {
            IconPanelContent = [
                <i key="el_0" className="fa fa-hourglass-half"></i>,
                <div key="el_1" className="icon-body">
                    <div className="end-of-service">{_('Usluga traje do' )} <strong>{' '}{endOfService}</strong></div>
                    <div>
                        <small>{_('credits_expiration_message', 'Nakon isteka zakupljenog pristupa bazi životopisa i dalje ćete imati pristup spremljenim životopisima.')}</small>
                    </div>
                </div>
            ];
		} else {
			css.push('no-credits');
            zeroCredits.push('credits-zero');
		}

		return <div className={ css.join(' ') }>
			<div className="icon-panel">
				<i className="fa fa-files-o"></i>
				<div className="icon-body">
					<div className="icon-title">
						{ _('Preostali pregledi životopisa') }
					</div>
					<div className="count" onClick={this.toggle}>{ total } <i className={zeroCredits.join(' ')}></i></div>
					<div className="credit-details">
						<div className="credits-body">{ vCredits }</div>
					</div>
					{noCredits}
				</div>
			</div>
			<div className="icon-panel">
                {IconPanelContent}
			</div>
		</div>
	}
}

export default Container.create(CreditsContainer);



// WEBPACK FOOTER //
// ./src/modules/subscription/credits.js